<template>
  <div id="app">
    <h1>Nextapaper</h1>

    <div v-if="isLoading" class="loading">
      Loading...
    </div>

    <div v-else-if="error" class="error-message">
      <p>Error: {{ error }}</p>
      <button @click="handleLogout" v-if="isAuthenticated">Logout</button>
    </div>

    <div v-else>
      <user-login v-if="!isAuthenticated" @login-success="handleLoginSuccess" />
      <div v-if="isAuthenticated">
         <button @click="handleLogout" class="logout-button">Logout</button>
         <bookmark-list :bookmarks="bookmarks" />
      </div>
    </div>

  </div>
</template>

<script>
import Cookies from 'js-cookie';
import UserLogin from './components/Login.vue';
import BookmarkList from './components/BookmarkList.vue';

export default {
  name: 'App',
  components: {
    UserLogin,
    BookmarkList
  },
  data() {
    return {
      isAuthenticated: false,
      bookmarks: [],
      isLoading: true, // Start loading initially to check auth/fetch data
      error: null,
    };
  },
  mounted() {
    this.checkAuthentication();
  },
  methods: {
    checkAuthentication() {
      const token = Cookies.get('instapaper_oauth_token');

      if (token) {
        console.log('Found auth cookies, attempting to fetch bookmarks.');
        this.isAuthenticated = true;
        this.fetchBookmarks();
      } else {
        console.log('No auth cookies found, showing login.');
        this.isAuthenticated = false;
        this.isLoading = false; // Not loading if not authenticated
      }
    },
    async fetchBookmarks() {
      this.isLoading = true;
      this.error = null;
      console.log('Fetching bookmarks from API...');

      try {
        const response = await fetch('/api/instapaper/bookmarks'); // Cookies are sent automatically

        if (!response.ok) {
          if (response.status === 401) {
            console.error('Authentication error fetching bookmarks (401). Logging out.');
            this.handleLogout(); // Specific handling for auth failure
          } else {
             // Handle other HTTP errors
             const errorData = await response.json().catch(() => ({ detail: 'Failed to parse error response.' }));
             throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
          }
        } else {
          const data = await response.json();
          if (data.status === 'success') {
            console.log('Bookmarks fetched successfully:', data.bookmarks);
            this.bookmarks = data.bookmarks;
          } else {
             throw new Error(data.detail || 'API returned failure status.');
          }
        }
      } catch (err) {
        console.error('Error fetching bookmarks:', err);
        // Avoid logging out for non-auth errors
        if (!this.error) { // Prevent overwriting specific 401 handling
           this.error = err.message || 'An unexpected error occurred.';
        }
        // If it wasn't an auth error (401), keep isAuthenticated potentially true
        // but show the error. If it *was* 401, handleLogout already set isAuthenticated=false.
      } finally {
        this.isLoading = false;
      }
    },
    handleLoginSuccess() {
      console.log('Login successful event received.');
      this.isAuthenticated = true;
      this.error = null; // Clear any previous errors
      this.fetchBookmarks(); // Fetch bookmarks immediately after login
    },
    handleLogout() {
      console.log('Handling logout: clearing cookies and resetting state.');
      Cookies.remove('instapaper_oauth_token');
      this.isAuthenticated = false;
      this.bookmarks = [];
      this.error = null; // Clear errors on logout
      this.isLoading = false; // Not loading after logout
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.loading {
  margin-top: 20px;
  font-style: italic;
}

.error-message {
  margin-top: 20px;
  color: red;
  border: 1px solid red;
  padding: 10px;
  display: inline-block; /* Center the box */
}

.logout-button {
  padding: 8px 15px;
  margin-bottom: 20px;
  background-color: #f44336; /* Red */
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}
.logout-button:hover {
  background-color: #d32f2f;
}
</style>
